import { getItemById } from './getItemById';
import { getUserCodesItem } from './getUserCodesItem';

/**
 * Returns whether a PIN key exists in the device's user_codes dictionary. The dictionary is resolved by id first
 * (the block references the exact user_codes item — more stable than a name), falling back to the device's
 * user_codes item by name only if that id is not found.
 * @param {string} userFieldValue - PIN key ("user" field value)
 * @param {string} userCodesItemId - id of the user_codes item referenced by the block
 * @param {Array} items - controller items
 * @param {string} deviceId - device id (used for the name-based fallback)
 * @returns {boolean}
 */
export const isExistingUserCodeKey = (userFieldValue, userCodesItemId, items, deviceId) => {
    const userCodesItem = getItemById(items, userCodesItemId) || getUserCodesItem(items, deviceId);

    return Boolean(userCodesItem?.value?.hasOwnProperty(userFieldValue));
};
